import axios from "axios";

// Microservice `game` (xem ikara-parent/appengine/.../dispatch.yaml route */game/*
// → service game; application.properties đặt spring.mvc.servlet.path=/game).
// Path khớp @RequestMapping("/daily-task/web") của
// vnapps.ikara.game.dailytask.controller.web.DailyTaskAdminController.
const BASE = "/game/daily-task/web";

/**
 * GET danh sách DailyTask. Trả về body {status, message, data: DailyTaskDTO[]}.
 */
export function listDailyTasks() {
    return axios
        .get(global.config.apiDomain + BASE + "/list")
        .then(res => res.data);
}

/**
 * POST tạo-hoặc-cập-nhật DailyTask. Backend tự upsert theo id (cùng 1 endpoint
 * cho cả create lẫn update — frontend không cần phân biệt).
 *
 * @param {Object} dailyTask khớp CreateOrUpdateDailyTaskRequest:
 *   {id, name, group, image, requestNumber, bonus, type, rank, screenId, minLevel}
 */
export function saveDailyTask(dailyTask) {
    return axios
        .post(global.config.apiDomain + BASE + "/create-or-update", dailyTask, {
            headers: { "Content-Type": "application/json" },
        })
        .then(res => res.data);
}
